import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';
import { runOptimisticCachedQueryPatches } from './queryCacheUtils';

export const subcategoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubcategories: builder.query({
      query: (args = {}) => ({
        url: '/api/subcategories',
        params: buildListQueryParams(args),
      }),
      providesTags: ['Subcategories'],
    }),
    createSubcategory: builder.mutation({
      query: ({ name, category_id, status = true }) => ({
        url: '/api/subcategories',
        method: 'POST',
        body: {
          subcategory: {
            name,
            category_id,
            status,
          },
        },
      }),
      invalidatesTags: ['Subcategories'],
    }),
    updateSubcategory: builder.mutation({
      query: ({ id, name, category_id, status = true }) => ({
        url: `/api/subcategories/${id}`,
        method: 'PUT',
        body: {
          subcategory: {
            name,
            category_id,
            status,
          },
        },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'Subcategories',
        { type: 'Subcategories', id },
      ],
    }),
    updateSubcategoryStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/api/subcategories/${id}/update_status`,
        method: 'PATCH',
        body: { status },
      }),
      async onQueryStarted({ id, status }, { dispatch, getState, queryFulfilled }) {
        await runOptimisticCachedQueryPatches({
          dispatch,
          getState,
          queryFulfilled,
          endpointName: 'getSubcategories',
          updateDraft: (draft) => {
            const list = draft?.data;
            if (!Array.isArray(list)) return;
            const row = list.find((c) => Number(c.id) === Number(id));
            if (row) row.status = status;
          },
        });
      },
    }),
  }),
});

export const {
  useGetSubcategoriesQuery,
  useCreateSubcategoryMutation,
  useUpdateSubcategoryMutation,
  useUpdateSubcategoryStatusMutation,
} = subcategoryApi;
